import { Alert } from "antd";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getUserData } from "containers/Auth/Auth.selectors";
import { mapScreensToPaths } from "utils/RouterManager/utils";

/** Banner on the sync config screen that points to its successor, workspace syncs. */
export const SyncConfigDeprecationNotice = () => {
    const userData = useSelector(getUserData);
    return (
        <Alert
            className="syncConfigDeprecationNotice"
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            message={
                <>
                    Sync configs are deprecated. To link the workspaces of your organization, use{" "}
                    <Link to={mapScreensToPaths.workspaceSyncs(userData?.workspace_id ?? "")}>
                        workspace syncs
                    </Link>
                    . Existing sync configs keep working.
                </>
            }
        />
    );
};
